import { render, staticRenderFns } from "./paper-manage.vue?vue&type=template&id=37aaa17a&scoped=true"
import script from "./paper-manage.vue?vue&type=script&lang=js"
export * from "./paper-manage.vue?vue&type=script&lang=js"
import style0 from "./paper-manage.vue?vue&type=style&index=0&id=37aaa17a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aaa17a",
  null
  
)

export default component.exports